if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class StickyAtc extends HTMLElement {
      connectedCallback() {
        this.mainQuantity = document.getElementById(this.dataset.quantityId);
        this.observeTarget = document.getElementById(this.dataset.submitId);
        this.quantity = this.querySelector('.quantity__input');
        this.submitButton = this.querySelector('[type="submit"]');

        this.bindQuantitySync();
        this.bindSubmitFeedback();
        this.bindVisibility();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      // Only the on-page quantity input has name="quantity" and submits with
      // the form, so this one just mirrors it in both directions.
      bindQuantitySync() {
        if (!this.quantity || !this.mainQuantity) return;

        this.quantity.value = this.mainQuantity.value;

        const syncFromSticky = () => {
          if (this.mainQuantity.value === this.quantity.value) return;
          this.mainQuantity.value = this.quantity.value;
          this.mainQuantity.dispatchEvent(new Event('input', { bubbles: true }));
          this.mainQuantity.dispatchEvent(new Event('change', { bubbles: true }));
        };
        this.quantity.addEventListener('change', syncFromSticky);
        this.quantity.addEventListener('input', syncFromSticky);

        const syncFromMain = () => {
          if (this.quantity.value === this.mainQuantity.value) return;
          this.quantity.value = this.mainQuantity.value;
        };
        this.mainQuantity.addEventListener('change', syncFromMain);
        this.mainQuantity.addEventListener('input', syncFromMain);
      }

      // product-form.js only tracks the loading/disabled state of the
      // submit button living inside <product-form>, so this button needs
      // its own feedback driven off the events that submit already dispatches.
      bindSubmitFeedback() {
        if (!this.submitButton) return;

        this.submitButton.addEventListener('click', () => {
          if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
          this.submitButton.setAttribute('aria-disabled', 'true');
          this.submitButton.classList.add('loading');
        });

        const reset = () => {
          this.submitButton.classList.remove('loading');
          if (this.submitButton.hasAttribute('disabled')) return;
          this.submitButton.removeAttribute('aria-disabled');
        };
        document.addEventListener('cart:change', reset);
        document.addEventListener('cart:error', reset);
      }

      // Reveal once the on-page Add to cart button has scrolled above the
      // viewport; stay hidden while it is still visible or not yet reached.
      bindVisibility() {
        if (!this.observeTarget || !('IntersectionObserver' in window)) return;

        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            this.classList.toggle('is-visible', scrolledPast);
          });
        });
        this.observer.observe(this.observeTarget);
      }
    }
  );
}
